import { FC } from 'react';
import { Modal, Space } from 'antd';
import Image from "next/legacy/image";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Typography } from '@design-system/components';
import useRegionConfig from '@source/hooks/useRegionConfig';
import { getStaticCDN } from '@design-system/utils/utils';
import NotifyMeForm from './NotifyMeForm';

export const StyledModal = styled(Modal)`
  overflow: hidden;
  border-radius: 20px;
  padding-bottom: unset;
  width: 343px !important;
  ${(props) => props.theme.typo.familyGoogle.regular};

  @media screen and (min-width: 768px) {
    width: 640px !important;
  }

  .ant-modal-content {
    background: ${(props) => props.theme.color.background};
    position: relative;

    .ant-modal-close-x {
      display: none;
    }

    .ant-modal-body {
      padding: 30px 16px 24px 16px;

      @media screen and (min-width: 768px) {
        padding: 34px 24px;
      }
    }
  }

  .ant-modal-footer {
    display: none;
  }
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media screen and (min-width: 768px) {
    gap: 16px;
  }
`;

const StyledContent = styled.div<{ isSoldStatus?: boolean; isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  .notify-me-content-desc {
    text-align: center;
  }
`;

const StyledGoBackBtn = styled(Button)`
  width: 100%;
  color: ${(props) => props.theme.color.linkHighEmphasis};
  ${(props) => props.theme.typo.style.mainButtonOrLink};
`;

interface NotifyMeModalProps {
  onFinish: (values: unknown) => void;
  onClose: () => void;
}

const NotifyMeModal: FC<NotifyMeModalProps> = (props) => {
  const { t } = useTranslation();
  const {
    countryConfig: { country: countryCode },
  } = useRegionConfig();

  const { onFinish, onClose } = props;

  return (
    <StyledModal open>
      <StyledWrapper>
        <Image
          alt="notify-me"
          src={getStaticCDN('/assets/shared/notify-me/notify-me-modal.png')}
          width={246}
          height={90}
        />
        <StyledContent>
          <Typography variant="header" className="notify-me-content-title">
            {t('shared.notifyMe.modal.title')}
          </Typography>
          <Typography variant="body" className="notify-me-content-desc">
            {t('shared.notifyMe.modal.desc')}
          </Typography>
        </StyledContent>
        <NotifyMeForm countryCode={countryCode} onFinish={onFinish} />
        <StyledGoBackBtn variant="text" onClick={onClose}>
          {t('shared.notifyMe.modal.backToListing')}
        </StyledGoBackBtn>
      </StyledWrapper>
    </StyledModal>
  );
};

export default NotifyMeModal;
